<script>
import mixin from "@/pages/inspection_reports/forms/mixin";

export default {
	mixins: [mixin],
	methods: {
		getGroups() {
			return [
				{
          'title': 'Algemene gegevens',
					'name': 'product',
					'component': 'default',
					'values': {
						'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
						'product_type': this.input({type: 'Default', label: 'Type', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
            'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
					}
				},
				{
					'title': 'Plaats van opstelling',
					'name': 'customer',
          'component': 'hidden',
					'values': {
						'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
						'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
						'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
					}
				},
				{
					'title': 'Conformiteit',
					'name': 'conformiteit',
					'component': 'default',
					'values': {
						'conformiteit_verzegeling_onbeschadigd': this.input({type: 'YesNo', label: 'Verzegeling onbeschadigd', value: this.getValue('conformiteit_verzegeling_onbeschadigd')}),
						'conformiteit_typekeuringscert': this.input({type: 'YesNo', label: 'Typekeuringscert. met bijlage + doc. aanw.', value: this.getValue('conformiteit_typekeuringscert')}),
						'conformiteit_merk_en_type_power_supply': this.input({type: 'YesNo', label: 'Merk en type power supply', value: this.getValue('conformiteit_merk_en_type_power_supply')}),
						'conformiteit_aanwezige_printplaten': this.input({type: 'YesNo', label: 'Aanwezige printplaten', value: this.getValue('conformiteit_aanwezige_printplaten')}),
						'conformiteit_meting_onmogelijk_tijdens_opwarmen': this.input({type: 'YesNo', label: 'Meting onmogelijk tijdens opwarmen', value: this.getValue('conformiteit_meting_onmogelijk_tijdens_opwarmen')}),
						'conformiteit_software_versie': this.input({type: 'YesNo', label: `Softwareversie : ${this.softwareVersion}`, value: this.getValue('conformiteit_software_versie')}),
						'conformiteit_checksum': this.input({type: 'YesNo', label: `Checksum : ${this.checksum}`, value: this.getValue('conformiteit_checksum'), option: this.getOptionValue('conformiteit_checksum')}),
						'conformiteit_toelating_en_serienr_op_afdruk_aanwezig': this.input({type: 'YesNo', label: 'Toelating en serienr. op afdruk aanwezig', value: this.getValue('conformiteit_toelating_en_serienr_op_afdruk_aanwezig')}),
						'conformiteit_lektest': this.input({type: 'YesNo', label: 'Lektest', value: this.getValue('conformiteit_lektest')}),
					}
				},
				{
					'title': 'Algemeen',
					'name': 'common',
					'component': 'default',
					'values': {
						'common_omgevingstemperatuur': this.input({type: 'YesNo', label: 'Omgevingstemperatuur +5 tot 40 °C', value: this.getValue('common_omgevingstemperatuur')}),
						'common_nl_handleiding': this.input({type: 'YesNo', label: 'NL handleiding en NL opschriften', value: this.getValue('common_nl_handleiding')}),
						'common_voedingsspanning': this.input({type: 'YesNo', label: 'Voedingsspanning', value: this.getValue('common_voedingsspanning')}),
						'common_electronische_mechanische_werking': this.input({type: 'YesNo', label: 'Electronische / mechanische werking', value: this.getValue('common_electronische_mechanische_werking')}),
						'common_optische_controle': this.input({type: 'YesNo', label: 'Optische contr. / alle onderdelen aanwezig', value: this.getValue('common_optische_controle')}),
					}
				},
				{
					'title': 'Lineariteitstest',
					'name': 'lineariteitstest',
					'component': 'default',
          'values': {
            'lineartest_0_cm3': this.input({type: 'YesNoCalculateForm2', label: '0 #/cm3', value: this.getValue('lineartest_0_cm3'), testValue: 0}),
            'lineartest_100000_cm3': this.input({type: 'YesNoCalculateForm2', label: '100.000 #/cm3', value: this.getValue('lineartest_100000_cm3'), testValue: 100000}),
            'lineartest_1000000_cm3': this.input({type: 'YesNoCalculateForm2', label: '1.000.000 #/cm3', value: this.getValue('lineartest_1000000_cm3'), testValue: 1000000}),
          },
				},
				{
					'name': 'slot',
					'component': 'default',
					'values': {
						'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
					}
				}
			]
		}
	}
}
</script>

<template>
	<FormRenderer
		ref="renderer"
		:inspectionReport="inspectionReport"
		:inspectionReportResponse="inspectionReportResponse"
		:customerProduct="customerProduct"
		:appointmentId="appointmentId"
	/>
</template>